var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entries.length)?_c('div',{staticClass:"status-badges"},_vm._l((_vm.entries),function(ref){
var code = ref[0];
var count = ref[1];
return _c('span',{key:code || 'empty',staticClass:"tags",class:{ 'tag-empty': !code },style:(code ? { backgroundColor: _vm.statusColor(code) } : {})},[_vm._v(" "+_vm._s(code || "Vazio")+": "+_vm._s(count)+" ")])}),0):_c('span',[_vm._v("—")])}
var staticRenderFns = []

export { render, staticRenderFns }